import "./index.css";
// import "./map.css";
// import { Loader } from "@googlemaps/js-api-loader";

export function setupInformation() {
  const container = document.querySelector(".container-information");

  if (container == null) {
    return;
  }

  const tabs = document.querySelector<HTMLDivElement>(
    ".container-information-tabs"
  );
  const contents = document.querySelectorAll<HTMLDivElement>(
    ".container-information-content"
  );

  if (tabs) {
    const handleTabClick = (event: MouseEvent): void => {
      const clickedTab = (event.target as HTMLElement).closest<HTMLDivElement>(
        ".container-information-tab"
      );
      if (!clickedTab) return;

      const targetName = clickedTab.dataset.name;
      if (!targetName) return;

      // tabs: add new active, then remove old active
      clickedTab.setAttribute("data-active", "");
      const activeTab = tabs.querySelector<HTMLDivElement>(
        ".container-information-tab[data-active]:not([data-name='" +
          targetName +
          "'])"
      );
      if (activeTab) {
        activeTab.removeAttribute("data-active");
      }

      // contents: remove all active, then add new active
      contents.forEach((content) => content.removeAttribute("data-active"));
      const targetContent = document.querySelector<HTMLDivElement>(
        `.container-information-content[data-name="${targetName}"]`
      );
      if (targetContent) {
        targetContent.setAttribute("data-active", "");
      }
    };

    tabs.addEventListener("click", handleTabClick);

    // scroll to tab by hash
    scrollToTabByHash();
    document.querySelectorAll("[data-anchor-tab]").forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const hash = link.getAttribute("data-anchor-tab");
        if (hash) {
          window.location.hash = "#" + hash;
          scrollToTabByHash();
        }
      });
    });
  }

  // scroll to tab by hash
  function scrollToTabByHash() {
    const hash = window.location.hash;
    if (hash) {
      const name = decodeURIComponent(hash.replace("#", ""));
      const tab = container?.querySelector(
        `.container-information-tab[data-name="${name}"]`
      );
      if (tab) {
        (tab as HTMLDivElement).click();
        window.scrollTo({
          top: (tab as HTMLElement)?.offsetTop,
          behavior: "smooth",
        });
      }
    }
  }

  // deprecated
  // google map popup
  /*
  const mapPopup = document.querySelector('[data-popup-id="information-map"]');
  const mapElement = document.getElementById("information-map");
  const mapData = document.getElementById("information-map-data");

  if (mapPopup && mapElement && mapData) {
    const loader = new Loader({
      apiKey: import.meta.env.VITE_GOOGLE_MAP_KEY,
      version: "weekly",
    });

    const mapOptions = {
      center: {
        lat: Number(mapData.dataset.lat),
        lng: Number(mapData.dataset.lng),
      },
      zoom: 15,
    };

    let mapLoaded = false;

    const loadMap = () => {
      if (mapLoaded) {
        return;
      }

      mapLoaded = true;

      loader.load().then(async () => {
        const { Map } = (await google.maps.importLibrary(
          "maps"
        )) as google.maps.MapsLibrary;
        const map = new Map(mapElement, mapOptions);

        const infowindow = new google.maps.InfoWindow({
          content: mapData.innerHTML,
        });

        const marker = new google.maps.Marker({
          position: mapOptions.center,
          map,
          icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABF1BMVEUAAAAAQ28AR2EAPFoAPVsAPFoAPVoAPVqww80APFoARGHg5+0AQ18APVoAPVsAPFsAQF0IRWUAPFsAPFsAPFrz9/cAPlsAPVwAPVsAPFsAPVvm7O8APVoAPVoCQFsAPVsAPVsAQ1u2yNAAPFoAQV/C0NfQ2+EAPFr7//8AQFkDQV/7+/j39/Pp59z////+/v/////////7/P31+Pj9/f3e5ur1+fnh6Oz8//+pvMgAPVnn7/Hl8vLe7++MxcXs6uL////9/f39/f39/f37//+JpbPm///4ti3///8AO1nOyKu8qmxYZ0ltcUWWhT+skDvFokrU0LnCuI7As4S8qGXVpjrZqDfprzHk4dXQy7G9pV/Io0TrsDBtV5aVAAAAR3RSTlMABAllbF12cblVB0kRektJFg1pWVJDOy4gYE5HRjYbQSYLs0QPqZ1uQigU/v7++PXm4MrGpZN7ekw1Mi4TDwb+zZ2Ykjw2CrrMaNIAAAF1SURBVDjL3dLXUsJAGIZhMYGYGBNSTAhSgqhIsaCiAord/IBdsd//dfinLFIks+OBB34nOXnmnd3JTv3NzltU7GAHjpuRYCFufxMA1ndbEbKJOej0HgG2mtM4QSB0PFd5dxzn4xWjipIjdoQdngC8PTvuPt1oXVxSFKSjcrUKlSeH7G4NNvZKIlqPDuROAe4x19/LA8B2PV4S8QTCN5yvQpnkhqKZuBcN2OUZ5noEDEcvvCg5HpS7w4ZEj6CWcKN92HF+XhdqtivJCUPgiulK30VCYdosJjI00HDlCLxtt9tX+L3B73UAl/Mobd+FQymFkgbqUt5oBHAhBC5qupxN+1AgcHwIo3wyb9BAy03SQMZNUsAZ1dKSKf8u0yGXQchoOoGzYZBlorpMCfnfwvERKP1POHE+lGmgOvBnFDGeKDaMVFKzGJaLxebIYjGOHXwUOYS2aWQlPsqoLIeUjCtgkCdQQJixzXRW1jULZYEjK7Aq4z3cL7b5+7Pf3qUCAAAAAElFTkSuQmCC",
        });

        const openInfoWindow = () => {
          infowindow.open({
            anchor: marker,
            map,
          });
        };

        openInfoWindow();

        marker.addListener("click", () => {
          openInfoWindow();
        });
      });
    };

    container.addEventListener("click", (event) => {
      if (event.target instanceof HTMLElement) {
        if (event.target.closest('[data-action="enlarge-map"]')) {
          loadMap();
          mapPopup.classList.add("element-popup__show");
        }
      }
    });
  }
  */
}
